import React, { useState, useEffect } from 'react'
import { Dropdown } from 'react-bootstrap'
import { isActiveRecord, isDeleteRecord, isInActiveRecord } from '../common/utilities/ConfirmationAlert';
import { MONGO_COMMANDS, LIST, getApiPath } from '../../api/ApiConst';
import CommandAddUpdate from './CommandAddUpdate';
import { useCallback } from 'react';
import TableFilter from '../constants/TableFilter';
import { useClient } from '../../config/ClientProvider';

const CommandList = () => {
    const { selectedClient } = useClient();
    const [drawCount, setDrawCount] = useState(0);
    const [showAddModel, setShowAddModel] = useState(false);

    const [commandObj, setCommandObj] = useState({
        id: "",
        name: "",
        value: "",
        type: "",
        collectionFrom: "",
    });

    // Command Create/Update Model show/close
    const toggleAddModel = () => {
        setShowAddModel(prev => !prev)
    }

    // Table Action Buttons
    const getTableActionButtons = (row) => {
        return (
            <Dropdown className='custom-dropdown'>
                <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                    <i className="fa fa-chevron-down"></i>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item
                        href={undefined}
                        onClick={() =>
                            handleUpdateCommandData(row)}
                    >
                        <i className="fa fa-edit me-2"></i> Edit
                    </Dropdown.Item>
                    <Dropdown.Item
                        href={undefined}
                        onClick={(row) =>
                            isDeleteRecord(row)
                            // handleTableDataDelete(row)
                        }
                    ><i className="fa fa-trash me-2"></i> Delete</Dropdown.Item>
                    <Dropdown.Item
                        href={undefined}
                        onClick={(row) =>
                            isActiveRecord(row)
                        }
                    ><i className="fa fa-circle-check me-2"></i> Active</Dropdown.Item>
                    <Dropdown.Item
                        href={undefined}
                        onClick={(row) =>
                            isInActiveRecord(row)
                        }
                    ><i className="fa fa-circle-xmark me-2" ></i> InActive</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown >
        )
    }

    // Create Modal
    const handleCreateCommandData = () => {
        let rObj = {
            // id: "",
            name: "",
            value: "",
            type: "",
            collectionFrom: "",
        };
        setCommandObj(rObj);
        toggleAddModel();
    }

    // Update Command Model
    const handleUpdateCommandData = data => {
        let rObj = {
            id: data._id,
            name: data.name,
            value: data.value,
            type: data.type,
            collectionFrom: data.collectionFrom,
        };
        setCommandObj(rObj);
        toggleAddModel();
    }

    const getCommandListView = useCallback(
        () => {
            return (
                <>
                    <div className="row justify-content-end">
                        <div className="col-12 px-0">
                            <div className="card">
                                <div className="card-body p-0">
                                    <div className='d-flex justify-content-end mb-3 me-0 table-info'>
                                        <a href={undefined} className="btn btn-primary" onClick={handleCreateCommandData}>
                                            Create New
                                        </a>
                                    </div>
                                    <TableFilter
                                        tableName="command"
                                        tableUrl={getApiPath(MONGO_COMMANDS, LIST)}
                                        paginationStatus={true}
                                        drawCount={drawCount}
                                        showRecordUpdateModel={handleUpdateCommandData}
                                        refreshTableData={refreshTableData}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )

        },
        [drawCount],
    );
    const refreshTableData = () => {
        setDrawCount((prev) => (prev + 1));
    };

    // useEffect to listen for selectedClient changes
    useEffect(() => {
        if (selectedClient) {
            refreshTableData();
        }
    }, [selectedClient]);

    return (
        <>

            {getCommandListView()}
            {showAddModel &&
                <CommandAddUpdate
                    show={showAddModel}
                    close={toggleAddModel}
                    object={commandObj}
                    successCallBack={() => setDrawCount((pre) => (pre + 1))}
                />
            }
        </>
    )
}

export default CommandList
